import {publicFormID} from "../Environment";
import {FormState, FormStateValues} from "../FormState";
import {PublicFormSubmissionData} from "../PublicFormSubmission";
import {PublishedForm} from "../PublishedForm";
import {request} from "./API";

interface PublicFormSubmissionParams {
  email: string;
  phone: string;
  first_name: string;
  last_name: string;
  role: string;
  gender: string | null;
  company_name: string;
  location_id: number | null;
  industry_id: string | null;
  number_of_employees: number | null;
  has_submitted: boolean;
  values: FormStateValues;
  filtered_section_ids: number[];
}

interface CreatePublicFormSubmissionResponse {
  token: string;
  public_form_submission: PublicFormSubmissionData;
}

export function current(): Promise<PublicFormSubmissionData> {
  return request<PublicFormSubmissionData>(
    "get",
    "public-form-submissions/current",
  );
}

export function create(
  formState: FormState,
  publishedForm: PublishedForm,
): Promise<CreatePublicFormSubmissionResponse> {
  return request<CreatePublicFormSubmissionResponse>(
    "post",
    "public-form-submissions",
    {
      data: {
        published_form_id: publishedForm.id(),
        public_form_named_id: publicFormID,
        public_form_submission: formStateToParams(formState),
      },
    },
  );
}

export function update(
  formState: FormState,
): Promise<PublicFormSubmissionData> {
  return request<PublicFormSubmissionData>(
    "put",
    "public-form-submissions",
    {
      data: {
        public_form_submission: formStateToParams(formState),
      },
    },
  );
}

export function addAdvisorSearchedSection(
  sectionID: number,
): Promise<PublicFormSubmissionData> {
  return request<PublicFormSubmissionData>(
    "patch",
    "public-form-submissions/add-advisor-searched-section",
    {
      data: {
        advisor_searched_section_id: sectionID,
      },
    },
  );
}

export function requestReturnLink(email: string): Promise<null> {
  return request<null>(
    "patch",
    "public-form-submissions/request-return-link",
    {data: {email, public_form_named_id: publicFormID}},
  );
}

function formStateToParams(formState: FormState): PublicFormSubmissionParams {
  return {
    email: formState.detail("email"),
    phone: formState.detail("phone"),
    first_name: formState.detail("first_name"),
    last_name: formState.detail("last_name"),
    role: formState.detail("role"),
    gender: formState.detail("gender"),
    company_name: formState.detail("company_name"),
    location_id: formState.detail("location_id"),
    industry_id: formState.detail("industry_id"),
    number_of_employees: formState.detail("number_of_employees"),
    has_submitted: formState.hasSubmitted(),
    values: formState.values(),
    filtered_section_ids: formState.filteredSectionIDs(),
  };
}
